// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-form {
  max-width: 350px;
}

.register-field {
  width: 100%;
}

.buttons {
  margin-top: 8px;
}

.test-user-list {
  font-size: 12px;
}

.shift-right {
  right: 1.15rem;
}

.forget-password {
  margin-top: 8px;
}

.buttons {
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/auth/register/register-form/register-form.component.scss","webpack://./src/styles/abstracts/_variables.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,eCDS;ADAX;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,eCbS;ADYX;;AAIA;EACE,eCjBS;ADgBX","sourcesContent":["@use './src/styles/abstracts/variables' as var;\r\n\r\n.register-form {\r\n  max-width: 350px;\r\n}\r\n\r\n.register-field {\r\n  width: 100%;\r\n}\r\n\r\n.buttons {\r\n  margin-top: var.$space-sm;\r\n}\r\n\r\n.test-user-list {\r\n  font-size: 12px;\r\n}\r\n\r\n.shift-right {\r\n  right: 1.15rem;\r\n}\r\n\r\n.forget-password {\r\n  margin-top: var.$space-sm;\r\n}\r\n\r\n.buttons {\r\n  margin-top: var.$space-sm;\r\n}\r\n","// Brand Colors\r\n$brand-blue-light: #a8c0e4;\r\n$brand-maroon: #a12041;\r\n$brand-maroon-swap: #1a8435;\r\n$brand-gray-darker: #58595b;\r\n$brand-gray-dark: #808285;\r\n$brand-gray-light: #a7a9ac;\r\n$brand-gray-lightest: #d1d3d4;\r\n\r\n// Spacing\r\n$space-sm: 8px;\r\n$space-md: 16px;\r\n$space-lg: 24px;\r\n\r\n// Side Nav\r\n$side-nav-width: 210px;\r\n$side-nav-color: #f6f6f6;\r\n$side-nav-color-hover: rgba(0, 0, 0, 0.04);\r\n\r\n// Media Res\r\n$tablet: 768px;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
